export default class TimeOfDay {
  public static readonly Day = 1000;
  public static readonly Midnight = 18000; 
  public static readonly Night = 13000;
  public static readonly Noon = 6000;
  public static readonly Sunrise = 23000;
  public static readonly Sunset = 12000;
}